export default __webpack_public_path__ + "static/media/oil-change.aeb611ad.webp";